const React = require('react');
const { connect } = require('react-redux');
import { formatText } from 'core/i18n';
import { RadioButton } from 'components/RadioButton/RadioButton';
const { TaxationElements } = require('./taxationElements');
const { getNameCountryByCountry } = require('utilities/multiLanguageHelper');
const { getLimitTaxationElements } = require('utilities/logicByCountry');

class TaxationQuestions extends React.Component {
    constructor(props) {
        super(props);

        this.buildQuestions = this.buildQuestions.bind(this);
    }

    componentDidUpdate() {
        const { userProfile, formActions } = this.props;
        if (userProfile.taxationCounter && !Object.keys(userProfile.taxationCounter).length) {
            formActions.push('userProfile.taxationCounter', 1);
        }
    }

    buildQuestions(taxation) {
        const { userProfile, userProfileForm, formActions, handleSave, disabled } = this.props;

        const limit = getLimitTaxationElements();

        return (
            <TaxationElements
                title={formatText('field-taxationCountryAdditional')}
                taxation={taxation}
                disabled={disabled}
                handleSave={handleSave}
                userProfile={userProfile}
                userProfileForm={userProfileForm}
                formActions={formActions}
                limit={limit}
            />
        );
    }

    render() {
        const { userProfile, userProfileForm, formActions, handleSave, disabled } = this.props;
        let taxation = {};
        let questions;

        if (userProfile.taxation === 'true') {
            taxation = {
                answer: userProfile.taxation,
                delete: 'false',
            };
            questions = this.buildQuestions(taxation);
        }

        return (
            <div>
                <div>
                    <label>{formatText('passport-taxation', [formatText(getNameCountryByCountry())])}</label>
                    <RadioButton
                        profileModel="userProfile.taxation"
                        optionsList={[
                            {
                                label: formatText('field-taxationTrue'),
                                value: 'true',
                            },
                            {
                                label: formatText('field-taxationFalse'),
                                value: 'false',
                            },
                        ]}
                        userProfile={userProfile}
                        userProfileForm={userProfileForm}
                        formActions={formActions}
                        isUpdated={function () {
                            taxation.answer = userProfile.taxation;
                            if (userProfile.taxation === 'false') {
                                if (userProfile.taxationCounter) {
                                    userProfile.taxationCounter.map(value => {
                                        formActions.change('userProfile.taxation_country_' + value, '');
                                        formActions.change('userProfile.taxation_tin_code_' + value, '');
                                        formActions.change('userProfile.taxation_reason_' + value, '');
                                        formActions.setErrors('userProfile.taxation_country_' + value, false);
                                        formActions.setErrors('userProfile.taxation_tin_code_' + value, false);
                                        formActions.setErrors('userProfile.taxation_reason_' + value, false);
                                        const index = userProfile['taxationCounter'].indexOf(value);
                                        formActions.remove('userProfile.taxationCounter', index);
                                    });
                                }
                                formActions.reset('userProfile.taxationCounter');
                                taxation.taxationDetails = [];
                                taxation.delete = 'true';
                            }
                            handleSave('taxation', taxation);
                        }}
                        focusAnimated
                        disabled={disabled}
                    />
                </div>

                {questions}
            </div>
        );
    }
}

module.exports.constructor = TaxationQuestions;
module.exports.TaxationQuestions = connect(
    state => ({
        options: state.options,
    }),
    null
)(TaxationQuestions);
